export default __webpack_public_path__ + "static/media/1.8011740c.jpg";